import React, { useMemo } from 'react';

type ButtonVariant =
    | 'primary'
    | 'secondary'
    | 'inverted'
    | 'outlined'
    | 'swift'
    | 'disabled';

export interface IButtonStyled
    extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: ButtonVariant;
    className?: string;
}

const Button: React.FC<IButtonStyled> = ({
    variant = 'primary',
    className = '',
    disabled = false,
    children,
    ...rest
}) => {
    const variantClasses = useMemo(
        () => ({
            base: 'w-full h-full rounded-lg outline-none font-semibold flex items-center justify-center transition-opacity',
            primary:
                'bg-primary border border-primary text-white cursor-pointer',
            secondary:
                'bg-primary-50 border border-primary-50 text-[#00673e] cursor-pointer',
            inverted:
                'bg-secondary-600 border border-secondary-600 text-white cursor-pointer',
            outlined:
                'bg-white border border-gray-200 text-gray-800 z-10 cursor-pointer border-solid',
            swift: 'bg-swift-50 text-yellow-700 z-10 cursor-pointer',
            disabled:
                'bg-gray-300 border border-gray-300 text-white cursor-not-allowed opacity-50',
        }),
        []
    );

    const appliedVariant = disabled ? 'disabled' : variant;

    const compiledClassnames = [
        variantClasses.base,
        variantClasses[appliedVariant],
        className,
    ]
        .filter(Boolean)
        .join(' ')
        .trim();

    return (
        <button className={compiledClassnames} disabled={disabled} {...rest}>
            {children}
        </button>
    );
};

export default Button;
